import { Link, router } from "@inertiajs/react";
import api from "@/api";
import { useCallback, useState } from "react";
import List from "./List";
import Uploader from "./Uploader";

export default function Index({ candidates, q }) {
  const [isOpenUploader, setIsOpenUploader] = useState(false);
  const [searchTerm, setSearchTerm] = useState(q);

  const search = useCallback((e) => {
    if (e.key !== "Enter") return;
    e.preventDefault();
    router.get(api.candidates.index.path(), { q: searchTerm.trim() });
  }, [searchTerm, router, api.candidates.index.path()]);

  return (
    <div className="space-y-6">
      {/* 顶部操作栏 */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">简历库</h2>
          <p className="mt-1 text-sm text-gray-500">
            共 {candidates?.length || 0} 份简历
          </p>
        </div>
        <div className="flex flex-wrap gap-3">
          <button
            onClick={() => setIsOpenUploader(true)}
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            <svg
              className="-ml-1 mr-2 h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 4v16m8-8H4"
              />
            </svg>
            批量导入
          </button>
          {candidates && candidates.length > 0 && (
            <Link
              href={api.vacancies.new.path()}
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              <svg
                className="-ml-1 mr-2 h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
              开始匹配
            </Link>
          )}
        </div>
      </div>

      {/* 搜索框 */}
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <svg
            className="h-5 w-5 text-gray-400"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
              clipRule="evenodd"
            />
          </svg>
        </div>
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyDown={search}
          placeholder="搜索姓名、技能、学校..."
          className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
        />
      </div>

      {/* 简历列表 */}
      <List candidates={candidates} />

      {/* 模态框 */}
      <Uploader
        isOpen={isOpenUploader}
        onClose={() => setIsOpenUploader(false)}
      />
    </div>
  );
}
